
import React from 'react';
import { Progress } from '@/components/ui/progress';
import { Button } from '@/components/ui/button';
import { EnrolledCourse, Course } from '@/types';

interface EnrolledCoursesListProps {
  enrolledCourses: EnrolledCourse[];
  courses: Course[];
  onContinue: (courseId: string, moduleId: string) => void;
}

const EnrolledCoursesList: React.FC<EnrolledCoursesListProps> = ({
  enrolledCourses,
  courses,
  onContinue
}) => {
  // Find the full course details for an enrolled course
  const getCourseDetails = (courseId: string) => {
    return courses.find(course => course.id === courseId);
  };

  return (
    <div className="space-y-4">
      {enrolledCourses.map(enrolledCourse => {
        const course = getCourseDetails(enrolledCourse.courseId);
        if (!course) return null;
        
        return (
          <div key={enrolledCourse.courseId} className="border rounded-lg p-4">
            <div className="flex justify-between items-start mb-2">
              <div>
                <h3 className="font-medium">{course.title}</h3>
                <p className="text-xs text-muted-foreground">
                  {course.level.charAt(0).toUpperCase() + course.level.slice(1)} • {course.modules?.length || 0} modules
                </p>
              </div>
              <Button 
                size="sm" 
                variant="default"
                onClick={() => onContinue(enrolledCourse.courseId, enrolledCourse.currentModuleId)}
              >
                Continue
              </Button>
            </div>
            <Progress value={enrolledCourse.progress} className="h-1.5 mb-1" />
            <p className="text-xs text-muted-foreground">{enrolledCourse.progress}% complete</p>
          </div>
        );
      })}
      
      {enrolledCourses.length === 0 && (
        <div className="text-center py-8">
          <p className="text-muted-foreground">You haven't enrolled in any courses yet.</p>
        </div>
      )}
    </div>
  );
};

export default EnrolledCoursesList;
